// extracted by css-extract-rspack-plugin
export default {"panel":"PersonalResults__panel--SSRWS","item":"PersonalResults__item--Nin47","selectWrap":"PersonalResults__selectWrap--hzcnc","actions":"PersonalResults__actions--LbpjB"};